import { StringsEnumDimension } from '@orus.eu/dimensions'
// Lives in this leaf package: the floor's cross-product UI element types are structural, so nothing central imports this dimension.
import { allEsMrpwProductVersions } from '@orus.eu/product'

export const esMrpwProductVersionDimension = new StringsEnumDimension({
  name: 'esMrpwProductVersion',
  displayKeys: { name: 'dimension_name_es_mrpw_product_version' },
  values: allEsMrpwProductVersions,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
